import styles from "../../index.module.scss";
import SendBtn from "../../../../assets/images/send.svg";
import { useContext, useEffect, useRef, useState } from "react";
import { networkContext } from "../../../../contexts/NetworkContext/NetworkContextProvider";
import {
  SendMessageInWebinar,
  singleTypingIndicator,
} from "../../../../Managers/Chat";

export const ChatSectionInput = ({ user, webinarDetails, chatUser }) => {
  const { roomId } = useContext(networkContext);

  const inputRef = useRef(null);

  const [message, setMessage] = useState("");

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!message.trim()) return;
    SendMessageInWebinar(
      webinarDetails.id,
      message,
      roomId,
      user.displayName,
      user.uid,
      chatUser
    );

    setMessage("");
  };

  useEffect(() => {
    if (!inputRef.current) {
      return;
    }
    // inputRef.current.focus();
    inputRef.current.onfocus = () => {
      singleTypingIndicator(webinarDetails.id, roomId, user.uid, true);
    };
    inputRef.current.onblur = () => {
      singleTypingIndicator(webinarDetails.id, roomId, user.uid, false);
    };

    // inputRef.current.addEventListener("focusein", () => {
    //   singleTypingIndicator(webinarDetails.id, roomId, user.uid, true);
    //   console.log("typing", true);
    // });

    // inputRef.current.addEventListener("focuseout", () => {
    //   singleTypingIndicator(webinarDetails.id, roomId, user.uid, false);
    //   console.log("typing", false);
    // });
  }, [inputRef.current]);

  return (
    <div className={styles.chatSection__input__box}>
      <form
        onSubmit={handleSubmit}
        className={styles.chatSection__input__box__input}
      >
        <textarea
          type="text"
          placeholder="Type a message"
          required={true}
          value={message}
          onChange={(e) => setMessage(e.target.value)}
          ref={inputRef}
          onKeyPress={(e) => {
            if (e.key === "Enter") {
              handleSubmit(e);
            }
          }}
        />
        <button type="submit">
          <img src={SendBtn} alt="send button" />
        </button>
      </form>
    </div>
  );
};
